import { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import {
  createNganyaGame,
  startRun,
  type GameSceneData,
} from '../games/nganya/NganyaGame';
import { EventBus, Events } from '../games/nganya/utils/EventBus';

interface Props {
  runRequest: (GameSceneData & { requestId: number }) | null;
  visible: boolean;
}

export function PhaserHost({ runRequest, visible }: Props) {
  const hostRef = useRef<HTMLDivElement>(null);
  const gameRef = useRef<Phaser.Game | null>(null);
  const readyRef = useRef(false);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;

    const game = createNganyaGame(
      host,
      Math.max(320, host.clientWidth || window.innerWidth),
      Math.max(480, host.clientHeight || window.innerHeight),
    );
    gameRef.current = game;

    const offReady = EventBus.on(Events.READY, () => {
      readyRef.current = true;
    });

    return () => {
      offReady();
      readyRef.current = false;
      game.destroy(true);
      gameRef.current = null;
    };
  }, []);

  useEffect(() => {
    const game = gameRef.current;
    if (!game || !runRequest) return;

    const { requestId: _id, ...data } = runRequest;
    void _id;

    const launch = () => startRun(game, data);

    if (readyRef.current || game.textures.exists('fare')) {
      launch();
      return;
    }

    const off = EventBus.on(Events.READY, () => {
      off();
      launch();
    });
    const t = window.setTimeout(() => {
      if (game.textures.exists('fare')) launch();
    }, 400);
    return () => {
      off();
      window.clearTimeout(t);
    };
  }, [runRequest]);

  return (
    <div
      ref={hostRef}
      className="phaser-host"
      style={{ visibility: visible ? 'visible' : 'hidden' }}
      aria-hidden={!visible}
    />
  );
}
